const initialState = {
	name: '',
	// new/connecting/connected/disconnected/closed,
	state: 'new',
	inLobby: false,
	signInRequired: false,
	overRoomLimit: false,
	// access code to the room if locked and joinByAccessCode == true
	accessCode: '',
	// if true: accessCode is a possibility to open the room
	joinByAccessCode: true,
	activeSpeakerId: null,
	showSettings: false,
	fullScreenConsumer: null, // ConsumerID
	fullScreenProducer: null, // ProducerID
	selectedPeers: [],
	spotlights: [],
	rolesManagerPeer: null, // peerId
	hideSelfView: false,
	rolesManagerOpen: false,
	joined: false,
	muteAllInProgress: false,
	muteAll: false,
	id: null,
	activeQA: false,
	lobbyPeersPromotionInProgress: false,
	stopAllVideoInProgress: false,
	closeMeetingInProgress: false,
	clearChatInProgress: false,
	clearFileSharingInProgress: false,
	roomPermissions: null,
	userRoles: null,
	allowWhenRoleMissing: null,
	recording: false,
	whiteboard: false,
	whiteboardSketch: {},
	allowSpeakAll: false,
	emoji: null,
	forceClose: false,
	parentId: null,
	startTime: null,
	timeLimit: null,
	kicked: false,
	waitingUsers: [],
	openChat: false,
	activeChat: true,
	closedCaption: false,
	chatReceivers: [{ displayName: 'All', userId: -1 }]
};

const room = (state = initialState, action) =>
{
	switch (action.type)
	{
		case 'SET_OPEN_CHAT':
			return { ...state, openChat: action.payload.openChat };

		case 'SET_ROOM_ID':
			return { ...state, id: action.payload.roomId };

		case 'SET_EMOJI_WEBINAR':
			return { ...state, emoji: action.payload.emoji };

		case 'ACTIVE_QA':
			return { ...state, activeQA: true };

		case 'ACTIVE_CC':
			return { ...state, closedCaption: action.payload.flag };

		case 'SET_PARENT_ID':
			return { ...state, parentId: action.payload.parentId };

		case 'SET_TIME_LIMIT':
			return { ...state, timeLimit: action.payload.timeLimit };

		case 'SET_START_TIME':
			return { ...state, startTime: action.payload.startTime };

		case 'INACTIVE_QA':
			return { ...state, activeQA: false };

		case 'ACTIVE_WHITEBOARD': {
			const { active } = action.payload;

			return { ...state, whiteboard: active };
		}

		case 'SET_ROOM_NAME': {
			const { name } = action.payload;

			return { ...state, name };
		}

		case 'SET_ROOM_FORCE_CLOSE': {
			return { ...state, forceClose: true };
		}

		case 'SET_ROOM_KICKED': {
			return { ...state, kicked: true };
		}

		case 'SET_ROOM_WHITEBOARD_SKETCH': {
			const { sketch } = action.payload;

			return { ...state, whiteboardSketch: sketch };
		}

		case 'SET_ROOM_WHITEBOARD_ACTIVE': {
			const { active } = action.payload;

			return { ...state, whiteboard: active };
		}

		case 'SET_ROOM_STATE': {
			const roomState = action.payload.state;

			if (roomState === 'connected') return { ...state, state: roomState };
			else if (roomState === 'closed') return initialState;
			else return { ...state, state: roomState, activeSpeakerId: null };
		}

		case 'SET_IN_LOBBY': {
			const { inLobby } = action.payload;

			return { ...state, inLobby };
		}

		case 'SET_SIGN_IN_REQUIRED': {
			const { signInRequired } = action.payload;

			return { ...state, signInRequired };
		}
		case 'SET_OVER_ROOM_LIMIT': {
			const { overRoomLimit } = action.payload;

			return { ...state, overRoomLimit };
		}
		case 'SET_ACCESS_CODE': {
			const { accessCode } = action.payload;

			return { ...state, accessCode };
		}

		case 'SET_JOIN_BY_ACCESS_CODE': {
			const { joinByAccessCode } = action.payload;

			return { ...state, joinByAccessCode };
		}

		case 'SET_ROLES_MANAGER_PEER': {
			const { rolesManagerPeer } = action.payload;

			return { ...state, rolesManagerPeer };
		}

		case 'SET_ROLES_MANAGER_OPEN': {
			const { rolesManagerOpen } = action.payload;

			return { ...state, rolesManagerOpen };
		}

		case 'SET_ROOM_ACTIVE_SPEAKER': {
			const { peerId } = action.payload;

			return { ...state, activeSpeakerId: peerId };
		}

		case 'TOGGLE_JOINED': {
			const joined = true;

			return { ...state, joined };
		}

		case 'TOGGLE_FULLSCREEN': {
			const { consumerId, producerId } = action.payload;
			const currentConsumer = state.fullScreenConsumer === consumerId;
			const currentProducer = state.fullScreenProducer === producerId;

			return {
				...state,
				fullScreenConsumer: currentConsumer || currentProducer ? null : consumerId,
				fullScreenProducer: currentConsumer || currentProducer ? null : producerId
			};
		}

		case 'SET_DISPLAY_MODE':
			return { ...state, mode: action.payload.mode };

		case 'ADD_SELECTED_PEER': {
			const { peerId } = action.payload;

			const selectedPeers = [ ...state.selectedPeers, peerId ];

			return { ...state, selectedPeers };
		}

		// Also listen for peers leaving
		case 'REMOVE_PEER':
		case 'REMOVE_SELECTED_PEER': {
			const { peerId } = action.payload;

			const selectedPeers = state.selectedPeers.filter(
				(peer) => peer !== peerId
			);

			return { ...state, selectedPeers };
		}

		case 'CLEAR_SELECTED_PEERS': {
			return { ...state, selectedPeers: [] };
		}

		case 'SET_SPOTLIGHTS': {
			const { spotlights } = action.payload;

			return { ...state, spotlights };
		}

		case 'CLEAR_SPOTLIGHTS': {
			return { ...state, spotlights: [] };
		}

		case 'SET_LOBBY_PEERS_PROMOTION_IN_PROGRESS':
			return { ...state, lobbyPeersPromotionInProgress: action.payload.flag };

		case 'MUTE_ALL_IN_PROGRESS':
			return { ...state, muteAllInProgress: action.payload.flag };

		case 'MUTE_ALL':
			return { ...state, muteAll: action.payload.flag };

		case 'STOP_ALL_VIDEO_IN_PROGRESS':
			return { ...state, stopAllVideoInProgress: action.payload.flag };

		case 'STOP_ALL_SCREEN_SHARING_IN_PROGRESS':
			return { ...state, stopAllScreenSharingInProgress: action.payload.flag };

		case 'CLOSE_MEETING_IN_PROGRESS':
			return { ...state, closeMeetingInProgress: action.payload.flag };

		case 'CLEAR_CHAT_IN_PROGRESS':
			return { ...state, clearChatInProgress: action.payload.flag };

		case 'CLEAR_FILE_SHARING_IN_PROGRESS':
			return { ...state, clearFileSharingInProgress: action.payload.flag };

		case 'SET_ROOM_PERMISSIONS': {
			const { roomPermissions } = action.payload;

			return { ...state, roomPermissions };
		}

		case 'SET_USER_ROLES': {
			const { userRoles } = action.payload;

			return { ...state, userRoles };
		}

		case 'SET_ALLOW_WHEN_ROLE_MISSING': {
			const { allowWhenRoleMissing } = action.payload;

			return { ...state, allowWhenRoleMissing };
		}

		case 'SET_HIDE_SELF_VIEW': {
			const { hideSelfView } = action.payload;

			return { ...state, hideSelfView };
		}

		case 'SET_RECORDING_STATUS': {
			const { recording } = action.payload;

			return { ...state, recording };
		}

		case 'TOGGLE_WINDOW_CONSUMER':
		{
			const { consumerId } = action.payload;
			const currentConsumer = state.windowConsumer;

			if (currentConsumer === consumerId)
				return { ...state, windowConsumer: null };
			else
				return { ...state, windowConsumer: consumerId };
		}

		case 'SET_USER_INTO_WAITING': {
			const { waitingUsers } = action.payload;

			return { ...state, waitingUsers };
		}

		case 'ADD_USER_INTO_WAITING': {
			const { user } = action.payload;

			return { ...state, waitingUsers: [ ...state.waitingUsers.filter((u) => u.id !== user?.id), user ] };
		}

		case 'REMOVE_USER_FROM_WAITING': {
			const { userId } = action.payload;

			return { ...state, waitingUsers: state.waitingUsers.filter((el) => el.id !== userId) };
		}

		case 'SET_ACTIVE_CHAT': {
			const { roomId, activeChat } = action.payload;

			if (roomId === state.id)
			{
				return { ...state, activeChat };
			}

			return state;
		}

		case 'SET_CHAT_RECEIVERS': {
			const { chatReceivers } = action.payload;

			return { ...state, chatReceivers };
		}

		default:
			return state;
	}
};

export default room;
